const SvgArrow = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_27842_533)">
        <path
          d="M15.4941 5.39177C15.3359 5.39551 15.1855 5.46164 15.0758 5.57575L9.49999 11.1515L3.92421 5.57575C3.86829 5.51828 3.80143 5.47259 3.72756 5.44139C3.65369 5.41019 3.57432 5.39412 3.49413 5.39411C3.37477 5.39414 3.25813 5.42977 3.15912 5.49644C3.06012 5.56311 2.98324 5.65779 2.93833 5.76837C2.89342 5.87896 2.8825 6.00043 2.90698 6.11725C2.93147 6.23408 2.99023 6.34094 3.07577 6.42419L9.07577 12.4242C9.1883 12.5367 9.34089 12.5999 9.49999 12.5999C9.65909 12.5999 9.81168 12.5367 9.92421 12.4242L15.9242 6.42419C16.0113 6.3404 16.0711 6.23224 16.0958 6.11389C16.1204 5.99554 16.1087 5.87251 16.0622 5.76091C16.0157 5.64932 15.9366 5.55437 15.8352 5.4885C15.7339 5.42263 15.615 5.38892 15.4941 5.39177Z"
          fill="#2B2B2B"
        />
      </g>
      <defs>
        <clipPath id="clip0_27842_533">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgArrow;
